import { z } from 'zod'

import { BusinessErrorSchema } from 'shared/api/common/schemas/errors'

export const InvalidLinkErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('share_hash'),
})

export const BlankPageErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('page_id'),
})
